var map = {
  "./cs.json": [
    "VCr",
    [
      78
    ]
  ],
  "./en.json": [
    "FmC",
    [
      "3z"
    ]
  ],
  "./pl.json": [
    "Hav",
    [
      "pc"
    ]
  ],
  "./ru.json": [
    "p6W",
    [
      "f2a"
    ]
  ],
  "./tr.json": [
    "ZNd",
    [
      "b3"
    ]
  ],
  "./ja.json": [
    "aMN",
    [
      "kv"
    ]
  ],
  "./zh.json": [
    "Ug",
    [
      "yr"
    ]
  ],
  "./pt-br.json": [
    "Pt",
    [
      "xpf"
    ]
  ],
  "./de.json": [
    "JD",
    [
      "n2"
    ]
  ],
  "./es.json": [
    "MxU",
    [
      "ed"
    ]
  ],
  "./fr.json": [
    "vX",
    [
      "dji"
    ]
  ],
  "./it.json": [
    "UBa",
    [
      "yy"
    ]
  ],
  "./ko.json": [
    "pJx",
    [
      "nj"
    ]
  ],
  "./pt.json": [
    "gl",
    [
      "6x"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "D2";
module.exports = __rspack_async_context;
